import { Service } from '@angular/core';
import { PageDataServiceBase, PageState, PageStateBase, PageStateService } from '@portal-core/data/page/services/page.state';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';
import { ProjectChecklistsState } from '@portal-core/project-checklists/services/project-checklists/project-checklists-data.service';

@PageState({
  name: 'projectChecklistPageState',
  actionName: 'ProjectChecklistsPage'
})
export class ProjectChecklistsPageState extends PageStateBase { }

@Service()
@PageStateService<ProjectChecklist>({
  pageState: ProjectChecklistsPageState,
  itemCollectionState: ProjectChecklistsState
})
export class ProjectChecklistsPageDataService extends PageDataServiceBase<ProjectChecklist> {
  override state = ProjectChecklistsPageState;
}
